package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.VisibilityOffW500Rounded: ImageVector
    get() {
        if (_visibilityOffW500Rounded != null) {
            return _visibilityOffW500Rounded!!
        }
        _visibilityOffW500Rounded = Builder(name = "VisibilityOffW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(607.0f, 333.0f)
                quadToRelative(25.65f, 25.65f, 38.79f, 58.95f)
                quadToRelative(13.14f, 33.29f, 11.78f, 68.46f)
                quadToRelative(0.0f, 16.68f, -11.96f, 28.25f)
                quadToRelative(-11.96f, 11.58f, -28.63f, 11.58f)
                quadToRelative(-16.68f, 0.0f, -28.25f, -11.58f)
                quadToRelative(-11.58f, -11.57f, -11.58f, -28.25f)
                quadToRelative(4.28f, -21.45f, -2.28f, -41.03f)
                quadToRelative(-6.57f, -19.58f, -20.7f, -33.71f)
                quadToRelative(-14.13f, -14.13f, -33.7f, -21.57f)
                quadToRelative(-19.58f, -7.45f, -42.03f, -3.17f)
                quadToRelative(-16.2f, 0.0f, -27.66f, -11.95f)
                quadToRelative(-11.45f, -11.96f, -11.45f, -28.15f)
                quadToRelative(0.0f, -16.2f, 11.45f, -27.66f)
                quadToRelative(11.46f, -11.45f, 27.66f, -11.45f)
                quadToRelative(34.89f, -1.85f, 68.3f, 11.29f)
                quadTo(580.15f, 306.15f, 607.0f, 333.0f)
                close()
                moveTo(480.0f, 240.0f)
                quadToRelative(-16.85f, 0.0f, -32.82f, 1.26f)
                quadToRelative(-15.96f, 1.26f, -32.05f, 4.54f)
                quadToRelative(-18.43f, 2.77f, -33.49f, -6.19f)
                quadToRelative(-15.05f, -8.96f, -20.29f, -26.63f)
                quadToRelative(-5.24f, -17.68f, 4.1f, -33.63f)
                quadToRelative(9.33f, -15.96f, 27.01f, -18.96f)
                quadToRelative(21.56f, -4.28f, 43.39f, -6.04f)
                quadToRelative(21.82f, -1.76f, 44.15f, -1.76f)
                quadToRelative(138.67f, 0.0f, 253.85f, 73.07f)
                quadToRelative(115.17f, 73.08f, 175.89f, 197.23f)
                quadToRelative(4.24f, 8.72f, 6.48f, 18.06f)
                quadToRelative(2.24f, 9.33f, 2.24f, 19.05f)
                reflectiveQuadToRelative(-1.62f, 19.17f)
                quadToRelative(-1.62f, 9.46f, -5.86f, 18.18f)
                quadToRelative(-17.76f, 38.56f, -43.19f, 72.49f)
                quadToRelative(-25.42f, 33.92f, -55.99f, 62.68f)
                quadToRelative(-12.71f, 12.44f, -30.27f, 10.44f)
                quadToRelative(-17.55f, -2.0f, -28.75f, -16.72f)
                quadToRelative(-11.19f, -14.72f, -9.81f, -32.77f)
                quadToRelative(1.38f, -18.06f, 14.1f, -30.49f)
                quadToRelative(22.32f, -22.28f, 41.13f, -48.09f)
                quadToRelative(18.8f, -25.8f, 33.32f, -54.89f)
                quadToRelative(-50.48f, -100.76f, -144.62f, -160.38f)
                quadTo(592.76f, 240.0f, 480.0f, 240.0f)
                close()
                moveTo(480.0f, 767.41f)
                quadToRelative(-135.43f, 0.0f, -247.99f, -72.98f)
                quadToRelative(-112.55f, -72.97f, -177.03f, -192.65f)
                quadToRelative(-5.48f, -9.43f, -8.22f, -20.01f)
                quadToRelative(-2.74f, -10.57f, -2.74f, -21.77f)
                reflectiveQuadToRelative(2.24f, -21.51f)
                quadToRelative(2.24f, -10.32f, 7.72f, -20.51f)
                quadToRelative(19.52f, -39.28f, 45.54f, -74.83f)
                quadToRelative(26.02f, -35.54f, 58.83f, -65.3f)
                lineToRelative(-80.61f, -81.37f)
                quadTo(66.02f, 184.0f, 66.4f, 166.9f)
                quadToRelative(0.38f, -17.1f, 12.1f, -28.81f)
                quadToRelative(11.72f, -11.72f, 29.32f, -11.72f)
                quadToRelative(17.59f, 0.0f, 29.31f, 11.72f)
                lineToRelative(681.2f, 681.19f)
                quadToRelative(11.71f, 11.72f, 12.09f, 28.82f)
                quadToRelative(0.38f, 17.1f, -12.09f, 29.57f)
                quadToRelative(-11.72f, 11.72f, -29.2f, 11.72f)
                quadToRelative(-17.48f, 0.0f, -29.2f, -11.72f)
                lineToRelative(-134.5f, -132.74f)
                quadToRelative(-35.23f, 11.48f, -71.71f, 16.98f)
                reflectiveQuadToRelative(-73.72f, 5.5f)
                close()
                moveTo(219.85f, 338.63f)
                quadToRelative(-28.05f, 26.0f, -51.09f, 56.28f)
                quadToRelative(-23.04f, 30.29f, -40.04f, 65.09f)
                quadToRelative(50.0f, 101.0f, 144.26f, 160.5f)
                quadTo(367.24f, 680.0f, 480.0f, 680.0f)
                quadToRelative(18.8f, 0.0f, 36.85f, -2.26f)
                quadToRelative(18.04f, -2.26f, 36.85f, -5.02f)
                lineToRelative(-36.0f, -38.0f)
                quadToRelative(-9.81f, 2.76f, -18.85f, 4.02f)
                quadTo(489.8f, 640.0f, 480.0f, 640.0f)
                quadToRelative(-75.0f, 0.0f, -127.5f, -52.5f)
                reflectiveQuadTo(300.0f, 460.0f)
                quadToRelative(0.0f, -9.8f, 1.14f, -18.85f)
                quadToRelative(1.14f, -9.04f, 3.66f, -18.85f)
                lineToRelative(-84.95f, -83.67f)
                close()
                moveTo(544.59f, 427.09f)
                close()
                moveTo(386.65f, 505.67f)
                close()
            }
        }
        .build()
        return _visibilityOffW500Rounded!!
    }

private var _visibilityOffW500Rounded: ImageVector? = null
